

// import {DriveRouteInfo} from "./DriveRouteInfo";
import { DriveParameters } from "./DriveParameters";
import { DriveRouteItems } from "./DriveRouteItems";
import { DriveSimpleItems } from "./DriveSimpleItems";
import { DriveMapInfo } from "./DriveMapInfo";
import { XmlUtility } from "../../../common/XmlUtility";



/// <summary>
/// 驾车路线信息 oyyh,20161008添加注释
/// </summary>
export class DriveRouteInfo {

	constructor() {
		/// <summary>
		/// 终点
		/// </summary>
		this.dest = null;
		/// <summary>
		/// 路程，单位公里
		/// </summary>
		this.distance = 0;
		/// <summary>
		/// 时间，单位秒
		/// </summary>
		this.duration = 0;
		/// <summary>
		/// 驾驶地图信息
		/// </summary>
		this.mapinfo = null;
		/// <summary>
		/// 中点
		/// </summary>
		this.mid = null;
		/// <summary>
		/// 起点
		/// </summary>
		this.orig = null;
		/// <summary>
		/// 起终点、途经点及驾车方案信息
		/// </summary>
		this.parameters = null;
		/// <summary>
		/// 路径的点信息集合
		/// </summary>
		this.routelatlon = null;
		/// <summary>
		/// 详细的行驶信息
		/// </summary>
		this.routes = new DriveRouteItems();
		/// <summary>
		/// 简化的行驶信息，不一定存在
		/// </summary>
		this.simple = new DriveSimpleItems();

		this.crsCode="EPSG:4326";
		
	}

	getRouteItemRanges() {
		let ranges = new Array();
		if (!this.simple) return ranges;

		let tempSimpleItem = null;
		let segmentNumber = null;
		let numbers = null;
		let startIndex = null;
		let endIndex = null;
		let tempRouteItems = null;
		for (let tempIndex in this.simple.objects) {
			tempSimpleItem = this.simple.objects[tempIndex];

			segmentNumber = tempSimpleItem.segmentNumber;
			numbers = segmentNumber.split("-");
			startIndex = numbers[0];
			endIndex = numbers[1];
			tempRouteItems = this.routes.getRangeItems(startIndex, endIndex);
			ranges.push(tempRouteItems);
		}
		
		return ranges;
	}


	/**
		 *获取驾车路线信息（不对外开放） 
		 * @param dirveXmlString
		 * @return 
		 * 
		 */
	static GetDriveRouteInfo(dirveXmlString) {
		let driveInfo = null;
		if (dirveXmlString == null) return driveInfo;

		let driveObject = XmlUtility.parseXmlStringToJson(dirveXmlString);
		if (driveObject == null) return driveInfo;
		// let proxyObjParse=new ObjectProxyParse();
		// let proxyItems = proxyObjParse.Parse(dirveProxy);

		// let resultNodeProxyItem=proxyItems.getItemAt(0);
		// let resultNodeProxyObject = resultNodeProxyItem.proxyObject;

		// let paramsProxyObj =driveObject.parameters;// resultNodeProxyItem.FindFirstItemByName(DriveRouteInfo.Node_Parameters);
		// let routeProxyObj = resultNodeProxyItem.FindFirstItemByName(DriveRouteInfo.Node_Routes);
		// let simpleProxyObj = resultNodeProxyItem.FindFirstItemByName(DriveRouteInfo.Node_Simple);
		// let mapinfoProxyObj = resultNodeProxyItem.FindFirstItemByName(DriveRouteInfo.Node_Mapinfo);

		driveInfo = new DriveRouteInfo();
		driveInfo.dest = driveObject.dest;
		driveInfo.distance = driveObject.distance;
		driveInfo.duration = driveObject.duration;
		driveInfo.mid = driveObject.mid;
		driveInfo.orig = driveObject.orig;
		driveInfo.routelatlon = driveObject.routelatlon;
		driveInfo.parameters = DriveParameters.GetDriveParameters(driveObject.parameters);
		driveInfo.routes = DriveRouteItems.GetDriveRouteItems(driveObject.routes);
		driveInfo.simple = DriveSimpleItems.GetDriveSimpleItems(driveObject.simple);
		driveInfo.mapinfo = DriveMapInfo.GetDriveInfo(driveObject.mapinfo);
		return driveInfo;
	}

}//end DriveRouteInfo

